import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { debounceTime, distinctUntilChanged, fromEvent, tap } from 'rxjs';
import { AppMainComponent } from './app.main.component';
import { FocuslinkService } from './core/services/focuslink.service';
import { LocalDataStoreService } from './core/services/local-data-store.service';
import { MenuService } from './core/services/menu.service';
import { UserService } from './core/services/user.service';
import { UserRoleEnum } from './shared/models/enums/user-role.enum';
import { Store } from './shared/models/store';
import { User } from './shared/models/user.model';

@Component({
	selector: 'app-menu',
	templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
	@ViewChild('searchMenuInput') searchMenuInput: ElementRef;
	searchResult: menuModel[];
	searchTerm: string = undefined;
	seperator = { separator: true };

	user: User;
	userModel = [];

	constructor(
		public app: AppMainComponent,
		private focuslink: FocuslinkService,
		public menuService: MenuService,
		private localStorage: LocalDataStoreService,
		public userService: UserService
	) {}

	ngOnInit() {
		this.app.menuTheme = 'layout-sidebar-white';
		this.init();
	}

	async init() {
		this.user = await this.localStorage.get('user');

		this.menuService.appMenu.subscribe((menu) => {
			if (menu && menu.length > 0 && this.userService.venueService.subscriptionVenue.value?.key) {
				this.buildDisplayMenu(menu, this.userService.venueService.subscriptionVenue.value);
			}
		});

		this.userService.venueService.subscriptionVenue.subscribe((venue) => {
			if (venue) {
				console.log(`Venue changed now exists with ${venue.key}`);
				this.buildDisplayMenu(this.menuService.appMenu.value, venue);
			}
		});

		this.menuService.loadMenuFromApi();

		setTimeout(() => {
			fromEvent(this.searchMenuInput.nativeElement, 'keyup')
				.pipe(
					debounceTime(500),
					distinctUntilChanged(),
					tap((text) => {
						this.searchMenu(this.searchMenuInput.nativeElement.value.toLowerCase());
					})
				)
				.subscribe();
		}, 250);
	}

	buildDisplayMenu(menu: menuModel[], venue: Store) {
		if (menu.length > 0) {
			const favorites = menu.find((i) => i.label.toLowerCase() === 'favorites');
			favorites.items = [];
			if (this.userService.user.preferences.menusFavorite?.length > 0) {
				if (this.user.preferences.menusFavorite?.length > 0) {
					this.userService.user.preferences.menusFavorite.forEach((userFav) => {
						menu.forEach((parent) => {
							parent.items.forEach((child) => {
								if (child.key === userFav) {
									child.parentKey = favorites.key;
									favorites.items.push(child);
								}
							});
						});
					});
				}
			} else {
				//find original favorites
				const defaultFavoriteKeys = [
					'51552514-6e4d-4e32-8dd5-cb55efc8e647',
					'6c8ed6d0-ad61-44b2-babb-2cfacf07652e',
					'ab4726e8-4650-4368-b0f4-02f6374f01c5',
				];
				if (this.userService.user.role === UserRoleEnum.DEALERADMIN || this.userService.user.role === UserRoleEnum.DEALERUSER) {
					defaultFavoriteKeys.push('dcab8383-0916-4076-a238-3207f48e0ccb');
				}
				const favorites = menu.find((i) => i.label === 'Favorites');
				menu.forEach((parent) => {
					parent.items.forEach((child) => {
						if (defaultFavoriteKeys.some((i) => child.key === i)) {
							child.parentKey = favorites.key;
							favorites.items.push(child);
						}
					});
				});
			}
			menu.forEach((parent) => {
				const financeBilling = parent.items.find((i) => i.key === '68d5d415-da03-4eeb-b08a-442bfbe9d7f2');
				if (financeBilling) {
					financeBilling.hidden = !venue.externalDealerAccountingId;
				}

				if (
					parent.key === '8b142957-8a22-4199-96d4-1f289e9d21e0' &&
					!(
						this.userService.user.dealerKey === '6rtZ3iXZcEeUtppgXgQlzQ' ||
						this.userService.user.dealerKey === 'V3w5b8sWhUKIk3ARrpxRZg' ||
						this.userService.user.dealerKey === 'XS7KOjiJ30i5gGQJuf_D9Q'
					)
				) {
					parent.hidden = true;
				}
			});

			this.userModel = [...menu];
		}
	}

	onMenuClick(event) {
		this.app.onMenuClick(event);
	}

	searchMenu(input) {
		if (input === '') {
			this.searchResult = undefined;
			return;
		}
		this.searchResult = [];
		this.menuService.rawMenu.forEach((menuItem) => {
			if (
				menuItem.itemUserLevel <= this.user.role &&
				menuItem.parentKey &&
				(menuItem.label?.toLowerCase().includes(input) || menuItem.description?.toLowerCase().includes(input))
			) {
				if (!this.searchResult) {
					this.searchResult = [];
				}
				this.searchResult.push(menuItem);
			}
		});
	}

	searchClear() {
		if (this.searchTerm === '') {
			this.searchResult = undefined;
		}
	}
}
interface menuModel {
	key?: string;
	parentKey?: string;
	separator?: boolean;
	label?: string;
	faIcon?: string;
	faIconPrefix?: string;
	icon?: string;
	sortOrder?: number;
	itemUserLevel?: number;
	description?: string;
	userFavorite?: boolean;
	hidden?: boolean;

	routerLink?: string[];
	items?: menuModel[];
}
[];
